import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const PERSONA_CONFIG = {
  // developer: { label: 'DEVELOPER', color: '#30D158' },
  // recruiter: { label: 'RECRUITER', color: '#007AFF' },
  // athlete:   { label: 'ATHLETE',   color: '#FF9F0A' },
     developer: { label: 'DEVELOPER', color: '#30D158', icon: '⚙️' },
     recruiter: { label: 'RECUITER/ MANAGER', color: '#007AFF', icon: '📋' },
     athlete:   { label: 'FELLOW ATHLETE', color: '#FF9F0A', icon: '🏋️' },
};

const StatusBar = ({ persona }) => {
  const [time, setTime] = useState(new Date());
  const [battery, setBattery] = useState(null);
  // const [location, setLocation] = useState(null);

  // Real-time clock
  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  // Geolocation — reverse geocode to city name
  // useEffect(() => {
  //   if (!navigator.geolocation) return;

  //   navigator.geolocation.getCurrentPosition(
  //     async (pos) => {
  //       try {
  //         const { latitude, longitude } = pos.coords;
  //         const res = await fetch(
  //           `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json&addressdetails=1`,
  //           { headers: { 'Accept-Language': 'en' } }
  //         );
  //         const data = await res.json();
  //         const city =
  //           data.address?.city ||
  //           data.address?.town ||
  //           data.address?.village ||
  //           data.address?.county ||
  //           '';
  //         const state = data.address?.state || '';
  //         if (city && state) {
  //           setLocation(`${city}, ${state}`);
  //         } else if (city) {
  //           setLocation(city);
  //         }
  //       } catch {
  //         // Geocoding failed — don't show location
  //       }
  //     },
  //     () => {
  //       // Permission denied or error — don't show location
  //     },
  //     { enableHighAccuracy: false, timeout: 5000 }
  //   );
  // }, []);

  // Battery Status API
  useEffect(() => {
    let bat = null;

    const handleLevel = () => setBattery((prev) => (prev ? { ...prev, level: bat.level } : null));
    const handleCharging = () => setBattery((prev) => (prev ? { ...prev, charging: bat.charging } : null));

    if (navigator.getBattery) {
      navigator
        .getBattery()
        .then((b) => {
          bat = b;
          setBattery({ level: b.level, charging: b.charging });
          b.addEventListener('levelchange', handleLevel);
          b.addEventListener('chargingchange', handleCharging);
        })
        .catch(() => {});
    }

    return () => {
      if (bat) {
        bat.removeEventListener('levelchange', handleLevel);
        bat.removeEventListener('chargingchange', handleCharging);
      }
    };
  }, []);

  const config = PERSONA_CONFIG[persona] || PERSONA_CONFIG.developer;

  const formattedTime = time.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  const batteryPercent = battery ? Math.round(battery.level * 100) : null;

  const getBatteryColor = () => {
    if (!battery) return '#8E8E93';
    if (battery.charging) return '#30D158';
    if (battery.level <= 0.2) return '#FF3B30';
    if (battery.level <= 0.5) return '#FF9F0A';
    return '#30D158';
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="fixed top-0 left-0 right-0 z-[60] select-none"
      style={{
        height: '32px',
        background: 'rgba(0, 0, 0, 0.85)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
      }}
    >
      <div className="h-full max-w-7xl mx-auto px-4 flex items-center justify-between text-xs relative">
        {/* Left: Time + Location */}
        {/* <div className="flex items-center gap-3 min-w-0 flex-1"> */}
        {/* Left: Time */}
        <div className="flex items-center min-w-0 flex-1">

          <span className="text-pure-white font-medium tracking-wide" style={{ fontSize: '11px' }}>
            {formattedTime}
          </span>

          {/* {location && (
            <span className="flex items-center gap-1 text-gray-400" style={{ fontSize: '10px' }}>
              <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4 0C2.07 0 0.5 1.57 0.5 3.5C0.5 6.125 4 10 4 10C4 10 7.5 6.125 7.5 3.5C7.5 1.57 5.93 0 4 0ZM4 4.75C3.31 4.75 2.75 4.19 2.75 3.5C2.75 2.81 3.31 2.25 4 2.25C4.69 2.25 5.25 2.81 5.25 3.5C5.25 4.19 4.69 4.75 4 4.75Z"
                  fill="#8E8E93"
                />
              </svg>
              {location}
            </span>
          )} */}
        </div>

        {/* Center: HELLO {PERSONA} — absolutely centered */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.3 }}
          // className="absolute left-[45.5%] -translate-x-1/2 flex items-center gap-1.5"
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center gap-1.5 pointer-events-none"
          style={{ maxWidth: 'calc(100% - 140px)' }}
        >
          <div
            className="rounded-full flex-shrink-0"
            style={{
              width: '5px',
              height: '5px',
              backgroundColor: config.color,
              boxShadow: `0 0 6px ${config.color}80`,
            }}
          />
          <span
            className="font-semibold tracking-widest whitespace-nowrap overflow-hidden text-ellipsis"
            style={{
              fontSize: '10px',
              color: config.color,
              letterSpacing: '0.15em',
            }}
          >
            HELLO {config.label}
          </span>
        </motion.div>

        {/* Right: Battery only */}
        <div className="flex items-center gap-2 flex-1 justify-end">
          {batteryPercent !== null ? (
            <div className="flex items-center gap-1">
              <div className="relative flex items-center">
                <div
                  className="rounded-sm relative overflow-hidden"
                  style={{
                    width: '22px',
                    height: '10px',
                    border: `1px solid ${getBatteryColor()}`,
                    borderRadius: '2px',
                  }}
                >
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${batteryPercent}%` }}
                    transition={{ duration: 1, ease: 'easeOut', delay: 0.5 }}
                    style={{
                      height: '100%',
                      backgroundColor: getBatteryColor(),
                      borderRadius: '1px',
                    }}
                  />
                </div>
                <div
                  style={{
                    width: '2px',
                    height: '5px',
                    backgroundColor: getBatteryColor(),
                    borderRadius: '0 1px 1px 0',
                    marginLeft: '0.5px',
                  }}
                />
              </div>
              <span className="font-medium" style={{ fontSize: '10px', color: getBatteryColor() }}>
                {batteryPercent}%
                {battery.charging && (
                  <span className="ml-0.5" style={{ fontSize: '8px' }}>⚡</span>
                )}
              </span>
            </div>
          ) : (
            <span className="text-gray-500" style={{ fontSize: '10px' }}>
              ● Online
            </span>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default StatusBar;
